import * as React from "react";

const Spinner = (): React.ReactElement => {
  return (
    <>
      <i
        aria-hidden
        className="fas fa-spinner fa-spin"
        data-testid="spinner"
        title="loading"
      />
      <span className="sr-only">Loading</span>
    </>
  );
};

export default Spinner;
